import React, {useEffect, useState} from 'react'
import { CasoGeneralComponent } from 'defcol-caso-general'
import { useLocation } from 'react-router-dom'
import { obtenerDatosLlaves } from '../../store/actions/encargado-compania-action'
import { useDispatch, useSelector } from 'react-redux'
import { Card, Container } from 'react-bootstrap'
import Formulario from './formulario'
import { getConfiguracionForm } from '../../api/api-gestion-casos'

const GestionRecupero = () => {
    
    const {state}=useLocation()
    const idCasoLocation=state?.row?.IdCaso ? state.row.IdCaso:55//96
    const idImplicado=state?.row?.IdImplicado ? state.row.IdImplicado :1
    const idOrganizacionCaso =state?.row?.idOrganizacionCaso  ? state.row.idOrganizacionCaso:8600399880
    const dispatch = useDispatch()
    const [datosCaso, setDatosCaso] = useState(null)

    useEffect(()=>{
        dispatch(obtenerDatosLlaves({idCaso:idCasoLocation, idImplicado:idImplicado, idOrgCaso:idOrganizacionCaso}))

    },[dispatch])
  
  
    return (
        <div> 
            <Container>
                <Card className='mt-2'>
                    <Card.Header as='h6' className="text-center" style={{backgroundColor:"#4F517A", color:"white"}} >
                        {`Antecendentes del Caso ${idCasoLocation}`}
                    </Card.Header>
                    <Card.Body>
                            <CasoGeneralComponent idCaso={idCasoLocation} idImplicado={idImplicado} idOrganizacionCaso={idOrganizacionCaso} setDatosCaso={setDatosCaso} /> 
                    </Card.Body>
                </Card>
            </Container>
            <Formulario datosCaso = {datosCaso} idTarea={state?.row?.IdTarea}/>
        </div>
    )
}

export default GestionRecupero
